import { useParams } from "@tanstack/react-router";
import { useEffect, useRef } from "react";
import { useTitle } from "react-use";

import { trpc } from "@blis/trpc/react";

import { CommandMenuProvider } from "@/components/CommandMenu";
import { ErrorPage } from "@/components/ErrorPage";
import { LoadingPage } from "@/components/LoadingPage";
import { Accession } from "../components/Accession";

export const AccessionDetailPage = (params: { id: number }) => {
  const query = useParams({ from: "/_auth/_app/accessions_/$id/" });
  useTitle(`Accession - ${params.id}`);
  const ref = useRef<HTMLDivElement | null>(null);

  const { data, isLoading, error } = trpc.accession.get.useQuery(params);

  // biome-ignore lint/correctness/useExhaustiveDependencies: run with query update
  useEffect(() => {
    const container = ref.current?.parentElement;
    if (container) {
      container.scrollTop = 0;
    }
  }, [query]);

  if (isLoading) return <LoadingPage />;
  if (error) return <ErrorPage error={error} />;

  const accession = data;

  if (!accession) {
    console.error("Accession not found", params.id);
    return (
      <div className="h-full w-full flex items-center justify-center">
        ACCESSION NOT FOUND
      </div>
    );
  }

  return (
    <CommandMenuProvider>
      <Accession accession={accession} />
    </CommandMenuProvider>
  );
};
